import { ButtonsGroup } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { ExportAccountStatement } from './ExportAccountStatement'

export const AccountSideActions = (): ReactElement => {
  return (
    <ButtonsGroup>
      <ExportAccountStatement />
    </ButtonsGroup>
  )
}
